import React from 'react';
import PropTypes from 'prop-types';
import {imageUrl, rootUrl} from '../../../helpers/ApplicationHelper';

const LiveAuction = ({auction,onClickEvent}) => {
  const {time_left_str: auctionEndTime, current_bid, description, image_url, views, item_public_id} = auction;

  const normalizeLabel = () => {
    let words =  description.split(" ");
    return words[words.length - 1];
  };
  const label = normalizeLabel();

  return (
      <a href={rootUrl(`/items/${item_public_id}`)} className={'auction'} onClick={onClickEvent} data-section={'LiveAuction'} data-label={label}>
        <div className="header">
          <div className={`time-left ${(auctionEndTime.indexOf('-') !== -1 ? 'warning' : '')}`}> {auctionEndTime}</div>
          <div className="right">
            <div className="views">{views || 0}</div>
            <img alt='' className="eye-icon"
                 src={imageUrl('homepage/views.svg')}/>
          </div>
        </div>
        <div className="content">
          <img src={image_url} alt=""/>
          <div className="description">{description}</div>
          <div className="current-bid">Current bid: {current_bid}</div>
        </div>
      </a>
  );
};

LiveAuction.propTypes = {
  auction: PropTypes.object,
  onClickEvent:PropTypes.func
};

export default LiveAuction;